import PropTypes from "prop-types";
import {Text, View} from "react-native";
import {Colors} from "../colors";
import {useContext} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";

function FontAwesome(props:any){
    let font = "";
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);
    switch (props.type) {
        default:
        case 'solid':
            font = "fa_solid";
            break;
        case 'brand':
            font = "fa_brands";
            break;
        case 'regular':
            font = "fa_regular";
            break;
    }

    return <View style={props.containerStyle}><Text {...props} style={[{
        fontFamily: font,
        fontSize: props.size ?? 18,
        textAlign: "center",
        alignSelf: 'center',
        // color: props.color ?? getColorByTheme("lowConText", theme),
        color: props.color ?? colors.get("lowConText")
    }, props.style]}>{props.icon}</Text></View>;
}

FontAwesome.propTypes = {
    size: PropTypes.number,
    color: PropTypes.string,
    containerStyle: PropTypes.any,
    type: PropTypes.oneOf(['regular', 'brand', 'solid']),
    icon: PropTypes.string.isRequired,
    style: PropTypes.any
}

export default FontAwesome;